module.exports = __webpack_public_path__ + "img/black_chevron_left.f334187d.png";